import Vue from 'vue';

Vue.directive('scrollsync', {
  inserted: (el, binding) => {
    const otherElement = binding.value;
    const target = el.querySelector('.v-table__overflow');

    const callback = (evt) => {
      document.querySelector(`#${otherElement} .v-table__overflow`).scrollLeft = evt.target.scrollLeft
    }
    target.addEventListener('scroll', callback)

    el._scrollsync = {
      callback,
      target
    }
  },
  unbind: (el) => {
    if (!el._scrollsync) return
    const { callback, target } = el._scrollsync

    target.removeEventListener('scroll', callback)
    delete el._scrollsync
  }
});
